import {colors} from '@mui/material';

const MuiTableHead = {
    root: {
        backgroundColor: colors.grey[50]
    }
};
export default MuiTableHead;